// eslint-disable-next-line import/prefer-default-export
export const IGNORED_WORDS = [
  'de',
  'en',
  'in',
  'het',
  'een',
  'niet',
  'commercial',
  'maar',
  'is',
  'te',
  'ik',
  'voor',
  'van',
  'wel',
  'reclame',
  'dat',
  'deze',
  'aan',
  'om',
  'op',
  'met',
  'wat',
  'je',
  'er',
  'dit',
  'bij',
  'die',
  'ook',
  'zijn',
  'over',
  'geen',
  'zo',
  'als',
  'naar',
  'dan',
  'komt',
  'mij',
  'wordt',
  'heel',
  'vind',
  'beetje',
  'echt',
  'maken',
  'zou',
  'ze',
  'omdat',
  'moet',
];

export const PROVINCES = {
  nl: {
    drenthe: 'nl-dr',
    flevoland: 'nl-fl',
    friesland: 'nl-fr',
    gelderland: 'nl-ge',
    groningen: 'nl-gr',
    limburg: 'nl-li',
    'noord-brabant': 'nl-nb',
    'noord-holland': 'nl-nh',
    overijssel: 'nl-ov',
    utrecht: 'nl-ut',
    zeeland: 'nl-ze',
    'zuid-holland': 'nl-zh',
  },
  be: {
    brussel: 'be-3530',
    'waals-brabant': 'be-3529',
    'vlaams-brabant': 'be-3532',
    antwerpen: 'be-3535',
    limburg: 'be-490',
    luik: 'be-3528',
    namen: 'be-3526',
    henegouwen: 'be-489',
    luxemburg: 'be-3527',
    'west-vlaanderen': 'be-3534',
    'oost-vlaanderen': 'be-3533',
  },
  de: {
    niedersachsen: 'de-ni',
    'schleswig-holstein': 'de-sh',
    berlin: 'de-be',
    'mecklenburg-vorpommern': 'de-mv',
    bremen: 'de-hb',
    saarland: 'de-sl',
    bayern: 'de-by',
    thüringen: 'de-th',
    'sachsen-anhalt': 'de-st',
    sachsen: 'de-sn',
    brandenburg: 'de-bb',
    'nordrhein-westfalen': 'de-nw',
    'baden-württemberg': 'de-bw',
    hessen: 'de-he',
    hamburg: 'de-hh',
    'rheinland-pfalz': 'de-rp',
  },
  fa: {},
};

export const DASHBOARD_FILTERS = {
  gender: {
    m: false, // Male
    f: false, // Female
    o: false, // Other
  },
  provinces: [],
  age: {
    min: null,
    max: null,
  },
};


export const IS_SAFARI = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

export const RENDER_TYPES_DISPLAY = {
  stars: 'word.numeric',
  text: 'word.free_text_multi_line',
  input: 'word.free_text_single_line',
  check_boxes: 'word.multi_choice',
  radio_buttons: 'word.single_choice',
  media: 'word.media',
  no_field: 'word.text',
};

export const RENDER_TYPE_ICONS = {
  stars: 'fa fa-star',
  text: 'far fa-file-lines',
  input: 'far fa-file-lines',
  check_boxes: 'far fa-check-square',
  radio_buttons: 'fas fa-circle-dot',
  media: 'fab fa-youtube',
};

export const MEDIA_TYPE_CHOICES = [
  { key: 'video', value: 'word.video', icon: 'fab fa-youtube' },
  { key: 'image', value: 'word.image', icon: 'far fa-image' },
  { key: 'audio', value: 'word.audio', icon: 'fas fa-headphones' },
];

export const DIRECTION_CHOICES = [
  { key: 'horizontal', value: 'word.horizontal' },
  { key: 'vertical', value: 'word.vertical' },
];

export const DATA_VIEW_OPTIONS = {
  averages: {
    displayName: 'word.average',
    icon: 'bar-chart',
  },
  compareMode: {
    displayName: 'word.compare',
    icon: 'magnifying-glass-chart',
  },
  histogramFrequencies: {
    displayName: 'word.histogram',
    icon: 'chart-simple',
  },
  histogramNumeric: {
    displayName: 'word.histogram',
    icon: 'chart-simple',
  },
  raw: {
    displayName: 'phrase.all_answers',
    icon: 'list',
  },
  stacked100: {
    displayName: 'word.distribution',
    icon: 'pie-chart',
  },
  top10Words: {
    displayName: 'phrase.top_10_words',
    icon: 'chart-simple',
  },
};

export const ITEM_DATA_VIEW_OPTIONS = {
  check_boxes: [
    'histogramFrequencies',
    'raw',
  ],
  dropdown: [
    'stacked100',
    'histogramFrequencies',
    'raw',
  ],
  input: [
    'raw',
    'top10Words',
  ],
  radio_buttons: [
    'stacked100',
    'histogramFrequencies',
    'raw',
  ],
  slider: [
    'averages',
    'histogramNumeric',
  ],
  stars: [
    'averages',
    'histogramNumeric',
    'compareMode',
  ],
  text: [
    'raw',
    'top10Words',
  ],
  no_field: [
    'textualItem',
  ],
  media: [
    'media',
  ],
};
